<app-breadcrumb></app-breadcrumb>
<div class="card mb-0">
    <div class="card-body">
        <dtg-manage-car-list [listType]="DtgListType.list"></dtg-manage-car-list>
    </div>
</div>